import request from '@/utils/request.js';
import router from '@/router'

export default(vm) => {
	return {
		namespaced: true,
		state: {
			data: null
		},
		mutations: {
			data: (state, data) => {
				state.data = data;
			}
		},
		actions: {
			handle: (context, playload) => {
				const url = playload.url;
				const data = playload.data;
				const method = playload.method?playload.method:'get';
				const callback = playload.callback;
				const data1 = playload.data1 ? playload.data1 : false;
				const failCallback = playload.failCallback;
				if(method == 'get' && data1 === true){
				request.get(url,data).then(data => {
						if(callback) callback(data);
					}).catch(msg => {
						if(failCallback)	failCallback(msg)
						return;
					});
				}
				if(method == 'get'){
					request.get(url,data).then(data => {
						if(callback) callback(data);
					}).catch(msg => {
						context.rootGetters['alert'](msg);
					});
				}else if(method == 'get2'){
					request.get2(url,data).then(data => {
						if(callback) callback(data);
					}).catch(msg => {
						context.rootGetters['alert'](msg);
					});
				}else if(method == 'put'){
					request.put(url,data).then(data => {
						if(callback) callback(data);
					}).catch(msg => {
						context.rootGetters['alert'](msg);
					});
				}else if(method == 'post'){
					request.post(url,data).then(data => {
						if(callback) callback(data);
					}).catch(msg => {
						context.rootGetters['alert'](msg);
					});
				}else if(method == 'delete'){
					request.delete(url,data).then(data => {
						if(callback) callback(data);
					}).catch(msg => {
						context.rootGetters['alert'](msg);
					});
				}
			},
		}
	}
}



// WEBPACK FOOTER //
// ./src/store/form.js